import React from 'react';

const InputLabel = ({ title, id, value }) => {
  return (
    <label htmlFor={id} value={value} className="text-base text-dark">
      {title}
    </label>
  );
};

export default InputLabel;
